export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 mb-6">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-display text-foreground-950 mb-3">
            爆料投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-[600px] mx-auto">
            你有独家内幕？知道不为人知的真相？吃瓜爆料提供安全匿名的投稿渠道，严格保护爆料人隐私。
            所有投稿经过多源交叉验证后发布，让你的声音被百万瓜友听见。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="mailto:tips@chigua.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              发送邮件投稿
            </a>
            <span className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-600 font-medium rounded-md whitespace-nowrap text-sm">
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center"></i>
              匿名保护 · 安全可靠
            </span>
          </div>
          <p className="mt-4 text-xs text-foreground-400">
            投稿邮箱：tips@chigua.com | 响应时间：24小时内
          </p>
        </div>
      </div>
    </section>
  );
}